const useSalesforceSandbox = process.env.BI_USE_SALESFORCE_SANDBOX !== 'false';

const leadStageGateway = 'm98g9vdcge';
const leadLiveGateway = 'kj0j8ma8ni';
const newsletterSubscriptionsStageGateway = 'sdybgj1u3g';
const newsletterSubscriptionsLiveGateway = 'kafxbjl81i';

function postLeadGateway() {
  return useSalesforceSandbox ? leadStageGateway : leadLiveGateway;
}

function postNewsletterSubcriptionsGateway() {
  return useSalesforceSandbox
    ? newsletterSubscriptionsStageGateway
    : newsletterSubscriptionsLiveGateway;
}

function getErrbitEnvironment(gateway) {
  if (gateway === leadLiveGateway || gateway === newsletterSubscriptionsLiveGateway) {
    return 'live';
  }
  return 'stage';
}

function getErrbitKey(gateway) {
  if (gateway === leadLiveGateway || gateway === leadStageGateway) {
    return process.env.BI_SALESFORCE_POST_LEAD_ERRBIT_KEY;
  }
  return process.env.BI_SALESFORCE_POST_NEWSLETTER_SUBSCRIPTIONS_ERRBIT_KEY;
}

const notifyError = (gateway, payload) => {
  const request = new XMLHttpRequest();
  request.timeout = 3000;
  request.open(
    'POST',
    `https://errbit.boatinternational.com/api/v3/projects/123/notices?key=${getErrbitKey(gateway)}`,
    true
  );
  request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
  request.send(
    JSON.stringify({
      errors: [
        {
          type: 'Error',
          message: 'Error connecting to AWS Lambda',
          backtrace: []
        }
      ],
      environment: {},
      context: {
        notifier: {
          name: 'airbrake-js/node',
          version: '1.4.1',
          url: 'https://github.com/airbrake/airbrake-js/tree/master/packages/node'
        },
        environment: getErrbitEnvironment(gateway)
      },
      session: {},
      params: { gateway, payload }
    })
  );
};

const submit = async (gateway, basePayload) => {
  const payload = {
    ...basePayload,
    referrer: location.href,
    userAgent: navigator.userAgent
  };

  const request = new XMLHttpRequest();
  request.timeout = 10000;
  request.open('POST', `https://${gateway}.execute-api.eu-west-1.amazonaws.com/execute`, true);
  request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');

  request.onerror = () => {
    notifyError(gateway, payload);
  };

  request.send(JSON.stringify(payload));
};

const submitSalesforceLead = async (
  email,
  leadSource,
  firstName,
  lastName,
  company,
  website,
  countryOfResidence,
  phoneNumber,
  yachtBuilder,
  yachtLength,
  yachtName
) => {
  const basePayload = {
    company,
    countryOfResidence,
    email,
    firstName,
    lastName,
    phoneNumber,
    product: leadSource,
    salutation: null,
    website,
    yachtBuilder,
    yachtLength,
    yachtName
  };

  await submit(postLeadGateway(), basePayload);
};

const submitSalesforceNewsletter = async (
  firstName,
  lastName,
  email,
  products,
  residenceData,
  userRole = null
) => {
  const basePayload = {
    company: null,
    email,
    firstName,
    lastName,
    newsletters: products.join(','),
    countryOfResidence: residenceData.country,
    // The attribute below can be true, false or null
    additionalTermsAccepted: residenceData.additionalTermsAccepted
  };

  if (userRole) {
    basePayload.subscriberRole = userRole;
  } else {
    basePayload.subscriberRole = 'Other';
  }

  await submit(postNewsletterSubcriptionsGateway(), basePayload);
};

const RESIDENCE_COUNTRIES = [
  'Angola',
  'Argentina',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Barbados',
  'Belarus',
  'Belgium',
  'Bermuda',
  'Bosnia and Herzegovina',
  'Brazil',
  'Bulgaria',
  'Cambodia',
  'Canada',
  'China',
  'Colombia',
  'Costa Rica',
  'Croatia',
  'Cyprus',
  'Czechia',
  'Democratic Republic of the Congo',
  'Denmark',
  'Ecuador',
  'Egypt',
  'Equatorial Guinea',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Georgia',
  'Gibraltar',
  'Greece',
  'Hong Kong',
  'Hungary',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kuwait',
  'Latvia',
  'Lebanon',
  'Lithuania',
  'Luxembourg',
  'Malaysia',
  'Malta',
  'Mexico',
  'Monaco',
  'Morocco',
  'Netherlands',
  'New Zealand',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Panama',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russian Federation',
  'Saudi Arabia',
  'Serbia',
  'Singapore',
  'Slovakia',
  'South Africa',
  'South Korea',
  'Spain',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Thailand',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States Minor Outlying Islands',
  'United States of America',
  'Uzbekistan',
  'Venezuela',
  'Vietnam'
];

const RESIDENCE_HIGH_REGULATION_COUNTRIES = [
  'Austria',
  'Belgium',
  'Brazil',
  'Canada',
  'Colombia',
  'Costa Rica',
  'Denmark',
  'Egypt',
  'Germany',
  'Greece',
  'India',
  'Indonesia',
  'Italy',
  'Lithuania',
  'Luxembourg',
  'Mexico',
  'Monaco',
  'Netherlands',
  'Nigeria',
  'Norway',
  'Pakistan',
  'Panama',
  'Philippines',
  'Poland',
  'Saudi Arabia',
  'Serbia',
  'South Africa',
  'South Korea',
  'Spain',
  'Switzerland',
  'Thailand',
  'Vietnam'
];

export {
  submitSalesforceLead,
  submitSalesforceNewsletter,
  RESIDENCE_COUNTRIES,
  RESIDENCE_HIGH_REGULATION_COUNTRIES
};
